// extracted by mini-css-extract-plugin
export var closeButton = "_c4-1";
export var closeX = "_c4-3";
export var container = "_c4-0";
export var image = "_c4-2";